import React from 'react'
import { colors, alpha } from '../style'

const SubAgreement = ({ 
  text, 
  checked, 
  onChange, 
  isLabel,
  required,
  wasSent,
  pulseError
}) => {
  if (isLabel) {
    return <div css={sSubAgreementLabel}>{text}</div>
  }

  const handleClick = (e) => {
    // Prevent the click event from propagating if it's a link
    if (e.target.tagName === 'A') {
      e.stopPropagation();
    } else {
      onChange(); // Call onChange for other clicks
    }
  }

  return (
    <div css={sSubAgreement}>
      <div 
        css={sCheckboxWrapper}
        onClick={handleClick}
        onKeyPress={handleClick}
        role='button'
        tabIndex={0}
      >
        <div
          className={`form_agreement_check ${checked ? 'checked' : ''} ${pulseError ? 'pulse-error' : ''}`}
          css={[
            wasSent &&
            required &&
            !checked &&
            sError,
          ]}>
          <div 
            className='form_agreement_check_inside' 
            css={checked && sCheckboxChecked}
          />
        </div>
        <div className='form_agreement_text' dangerouslySetInnerHTML={{ __html: text }} />
      </div>
    </div>
  )
}

const sSubAgreementLabel = {
  fontSize: 10,
  fontWeight: 700,
  marginBottom: '0.25rem',
  color: colors.text.concat(alpha[60]),
}

const sCheckboxChecked = {
  transform: 'scale(1) !important',
}

const sError = {
  boxShadow: `0px 0px 0px 3px ${colors.red.concat(alpha[60])} !important`,
  backgroundColor: colors.red.concat(alpha[8]),
  opacity: '1 !important',
}

const sSubAgreement = {
  display: 'flex',
  width: '100%',
  '.form_agreement_text': {
    fontSize: 11,
    a: {
      textDecoration: 'underline',
      '&:hover': {
        textDecoration: 'none',
      }
    }
  }
}

const sCheckboxWrapper = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  width: '100%',
  cursor: 'pointer',
}

export default SubAgreement

